<template>
  <WrapperFormElements
    :label
    :required
    :hint
    :alertLabel
    :alertType
    :help
  >
    <BasicInputNumber
      v-model="modelValue"
      :pourcentage
      :default-value
      :separateur
      :decimal
      :disabled
      :size
      :validation-state
      :placeholder
      :icon-state
      :icon-name
      :deletable
      :readonly
      :maxlength
      :read-only-reason="props.readOnlyReason"
    />
  </WrapperFormElements>
</template>

<script setup lang="ts">
  import type { WrapperInputNumberProps, InputNumberModel } from '@designSystem/components'

  const props = defineProps<WrapperInputNumberProps>()

  const modelValue = defineModel<InputNumberModel>()
</script>
